import { render, staticRenderFns } from "./AddEventExtras.vue?vue&type=template&id=1da84f20&"
import script from "./AddEventExtras.vue?vue&type=script&lang=js&"
export * from "./AddEventExtras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddEventExtras.vue"
export default component.exports